import React, { useState } from 'react'
import { zeroday } from '../../assets/images';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';



const ZeroDayImage = ({ alertId, deviceId, details }) => {
    const [display, setDisplay] = useState(false)
        const [selectedImage] = useState(details.EvidenceURL);

        const openModal = (e) => {
            e.stopPropagation();
            setDisplay(true);
        }
    
        const closeModal = (e) => {
            setDisplay(false)
        }
  return (
    <>
        <div>
        {/* <button
        data-title='Zero Day'
                    className="TwoWayAudioToggle two-way-and-hooter-on-off"
                    onClick={(e) => openModal(e)}
                    >
                        <img
                          style={{ padding: "2px", height: "26px", color: 'white' }}
                            src={zeroday}
                          alt="location icon"
                        />
                    </button> */}
            <OverlayTrigger
                    placement="auto"
                    overlay={<Tooltip id="tooltip-bottom" style={{ zIndex: 99999 }}>Zero Day</Tooltip>}                
                >
                    <button
                    className="TwoWayAudioToggle two-way-and-hooter-on-off"
                    onClick={(e) => openModal(e)}
                    // style={{ position: 'relative', zIndex: 100000 }}
                    >
                        <img
                          style={{ padding: "2px", color: 'white' }}
                            src={zeroday}
                          alt="location icon"
                        />
                    </button>
                </OverlayTrigger>
        </div>
        <div onClick={(e) => e.stopPropagation()} >
            <Modal show={display} size='xl' id="tooltip-bottom" style={{ zIndex: 99999 }} dialogClassName="healthMonitorModel" onHide={() => setDisplay(false)}>
                <Modal.Header closeButton onHide={(e) => closeModal(e)}>
                    <Modal.Title>
                        Alert Id - {alertId}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                <div style={{
                    display: 'flex',
                    gap: '2rem',
                    justifyContent: 'center',
                    marginBottom: '1rem'
                }}>
                        <div className="PanelDetailDiv">
                                    <p>
                                      Site Name{" "}
                                      <span>
                                        {" "}
                                        - {details?.site}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="PanelDetailDiv">
                                    <p>
                                      Device Name{" "}
                                      <span>
                                        {" "}
                                        - {details?.deviceName}
                                      </span>
                                    </p>
                                  </div>
                        </div>
                    <div className='m-auto MapContainerFlex mapDiv' 
                    style={{height: '600px', width: '1000px', justifyContent: 'center' }}
                    >
                        
                          <div className='Map_Preview'>
                              <div className='Image_Container' style={{ height: '100%', padding: '0.5rem' }}>

                                  {
                                      selectedImage
                                          ?
                                          <img
                                              src={selectedImage}
                                              alt="Drop zone"
                                              style={{ width: '100%', height: '100%' }}
                                          />
                                          :
                                          <p className='CenterTextFont m-0' style={{ color: "#6c6c6c" }}>
                                              Zero day image not available
                                          </p>
                                  }

                              </div>
                          </div>

                                  
                        
                    </div>

                </Modal.Body>
            </Modal>
        </div>
    </>
    
  )
}

export default ZeroDayImage
